module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), (_vm.contractForm.schedule) ? _c('div', {
    staticClass: "pl10 mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("审核进展：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.contractForm.schedule.time * 1000)) + "  " + _vm._s(_vm.contractForm.schedule.desc))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.contractForm.schedule.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                (" + _vm._s(_vm.contractForm.schedule.content) + ")")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt20 ovh min_height"
  }, [_c('div', {
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同基本信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "contractForm",
    staticClass: "demo-ruleForm mt10",
    attrs: {
      "model": _vm.contractForm,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.contractForm.contractCode))])]), _vm._v(" "), (_vm.contractForm.parentContractId > 0) ? _c('el-form-item', {
    attrs: {
      "label": "供应商原合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.contractForm.parentContractCode))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.contractForm.supplierCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.contractForm.supplierName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作方式：",
      "prop": "cooperationType",
      "rules": [{
        required: true,
        message: '请选择合作方式'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "prop": "cooperationType",
      "placeholder": "请选择合作方式",
      "disabled": _vm.contractForm.parentContractId > 0
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.contractForm.cooperationType),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "cooperationType", $$v)
      },
      expression: "contractForm.cooperationType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "入仓",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "入仓（实销实结）",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自发货",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), (_vm.contractForm.cooperationType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "发货时效："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10",
    attrs: {
      "placeholder": "请选择发货时效"
    },
    model: {
      value: (_vm.contractForm.deliveryTime),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "deliveryTime", $$v)
      },
      expression: "contractForm.deliveryTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "48小时",
      "value": 48
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "72小时",
      "value": 72
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同开始时间："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": _vm.contractForm.parentContractId > 0,
      "type": "date",
      "placeholder": "请选择合同开始时间"
    },
    model: {
      value: (_vm.contractForm.contractStartDate),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "contractStartDate", $$v)
      },
      expression: "contractForm.contractStartDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同结束时间："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择合同结束时间"
    },
    model: {
      value: (_vm.contractForm.contractEndDate),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "contractEndDate", $$v)
      },
      expression: "contractForm.contractEndDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("合同条款-财务信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算主体：",
      "prop": "settlementBodyId",
      "rules": [{
        required: true,
        message: '请选择结算主体'
      }]
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "w193",
          attrs: {
            "disabled": _vm.contractForm.parentContractId > 0,
            "placeholder": "请选择结算主体"
          },
          model: {
            value: (_vm.contractForm.settlementBodyId),
            callback: function($$v) {
              _vm.$set(_vm.contractForm, "settlementBodyId", $$v)
            },
            expression: "contractForm.settlementBodyId"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "北京果敢时代科技有限公司",
            "value": 1
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "MAMA HONG KONG",
            "value": 2
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "天津果敢时代国际贸易有限公司",
            "value": 3
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "老师线下打款",
            "value": 5
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式：",
      "prop": "settlementType",
      "rules": [{
        required: true,
        message: '请选择结算方式'
      }]
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticClass: "w193",
          attrs: {
            "disabled": _vm.contractForm.parentContractId > 0,
            "placeholder": "请选择结算方式"
          },
          model: {
            value: (_vm.contractForm.settlementType),
            callback: function($$v) {
              _vm.$set(_vm.contractForm, "settlementType", $$v)
            },
            expression: "contractForm.settlementType"
          }
        }, [_c('el-option', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.contractForm.cooperationType == 1),
            expression: "contractForm.cooperationType ==1"
          }],
          attrs: {
            "label": "直采",
            "value": 1
          }
        }), _vm._v(" "), _c('el-option', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.contractForm.cooperationType == 1),
            expression: "contractForm.cooperationType ==1"
          }],
          attrs: {
            "label": "预付款",
            "value": 2
          }
        }), _vm._v(" "), _c('el-option', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.contractForm.cooperationType != 1),
            expression: "contractForm.cooperationType !=1"
          }],
          attrs: {
            "label": "实销实结",
            "value": 3
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算币种："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v("人民币")])]), _vm._v(" "), (_vm.contractForm.settlementType == 1 || _vm.contractForm.settlementType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期：",
      "prop": "settlementPaymentType",
      "rules": {
        required: true,
        type: 'number',
        message: '请选择结算账期类型'
      }
    }
  }, [_c('el-select', {
    staticClass: "w193",
    model: {
      value: (_vm.contractForm.settlementPaymentType),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "settlementPaymentType", $$v)
      },
      expression: "contractForm.settlementPaymentType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "按年结算",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按半年结算",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按季度结算",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按月结算",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按半月结算",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自定义",
      "value": 0
    }
  })], 1), _vm._v(" "), (_vm.contractForm.settlementPaymentType === 0) ? _c('el-input', {
    staticClass: "w193",
    attrs: {
      "placeholder": "请输入结算天数",
      "maxlength": 4
    },
    model: {
      value: (_vm.contractForm.settlementPaymentDays),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "settlementPaymentDays", _vm._n($$v))
      },
      expression: "contractForm.settlementPaymentDays"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contractForm.settlementPaymentType === 0) ? _c('span', [_vm._v("天")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.contractForm.settlementType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("添加分期付款比例")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.contractForm.settlementPaymentRateArr), function(domain, index) {
    return (_vm.contractForm.settlementType == 2) ? _c('el-form-item', {
      key: 'settlementPaymentRate' + index,
      staticClass: "ml60 mt20",
      attrs: {
        "label": '第' + (index + 1) + '期',
        "prop": 'settlementPaymentRateArr' + '[' + index + ']',
        "rules": {
          required: true,
          message: '请输入正确分期付款比例',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      staticClass: "w70",
      on: {
        "input": function($event) {
          _vm.contractForm.settlementPaymentRateArr[index] = _vm.contractForm.settlementPaymentRateArr[index].replace(/[^\-?\d.]/g, '')
        }
      },
      model: {
        value: (_vm.contractForm.settlementPaymentRateArr[index]),
        callback: function($$v) {
          _vm.$set(_vm.contractForm.settlementPaymentRateArr, index, $$v)
        },
        expression: "contractForm.settlementPaymentRateArr[index]"
      }
    }), _vm._v("%\n                        "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDomain(domain)
        }
      }
    }, [_vm._v("删除")])], 1) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否需要保证金："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star133"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "ml_10",
    attrs: {
      "disabled": _vm.contractForm.parentContractId > 0
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.contractForm.shouldDeposit),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "shouldDeposit", $$v)
      },
      expression: "contractForm.shouldDeposit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("供应商无需交保证金")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("供应商需交保证金")])])], 1)], 1), _vm._v(" "), (_vm.contractForm.shouldDeposit == 1) ? _c('el-form-item', {
    attrs: {
      "label": "保证金：",
      "prop": "deposit",
      "rules": {
        required: true,
        type: 'number',
        message: '请填写正确的保证金'
      }
    }
  }, [_c('el-input', {
    staticClass: "w193",
    attrs: {
      "placeholder": "",
      "maxlength": 10,
      "disabled": _vm.contractForm.parentContractId > 0
    },
    model: {
      value: (_vm.contractForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.contractForm, "deposit", _vm._n($$v))
      },
      expression: "contractForm.deposit"
    }
  }), _vm._v("\n                        人民币\n                    ")], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货款支付方式："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star120"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "ml_10"
  }, [_vm._v("甲方将货款直接支付到乙方的如下银行账户")])]), _vm._v(" "), _c('el-table', {
    ref: "singleTable",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.contractForm.accounts,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio', {
          staticClass: "radio",
          attrs: {
            "label": scope.row.id
          },
          model: {
            value: (_vm.contractForm.bankAccountId),
            callback: function($$v) {
              _vm.$set(_vm.contractForm, "bankAccountId", $$v)
            },
            expression: "contractForm.bankAccountId"
          }
        }, [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "银行开户名",
      "min-width": "200",
      "align": "center",
      "prop": "accountName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "银行帐号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankName",
      "label": "银行名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.contractForm.registeredCountry != 1) ? _c('el-table-column', {
    attrs: {
      "prop": "swiftCode",
      "label": "SwiftCode",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contractForm.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contractForm.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("线上合同信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), (!_vm.contractForm.parentContractId) ? _c('div', [(_vm.contractForm.auth.edit) ? _c('el-button', {
    staticClass: "ml115 mt20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectAgree
    }
  }, [_vm._v("选择线上合同")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "main_word"
  }, [_vm._v(" （请为供应商选择合同，之后直接在线上完成合同相关信息填写）")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "150px",
      "margin-top": "20px"
    }
  }, _vm._l((_vm.contractTemplate.templateContents), function(val) {
    return _c('div', {
      staticClass: "agree_wrap"
    }, [_c('div', {
      staticClass: "in_block"
    }, [_c('span', {
      staticClass: "agree"
    }, [_vm._v(_vm._s(val.name))]), _vm._v(" "), (_vm.contractForm.auth.edit) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.editAgree(val)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "合同线上模板",
      "visible": _vm.contractTemplate.agreeDialog,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.contractTemplate, "agreeDialog", $event)
      }
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "clearfix container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.contractTemplate.list), function(val) {
    return _c('div', {
      staticClass: "col-lg-3",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('el-radio-group', {
      on: {
        "change": _vm.argeenSel
      },
      model: {
        value: (_vm.contractTemplate.fatherId),
        callback: function($$v) {
          _vm.$set(_vm.contractTemplate, "fatherId", $$v)
        },
        expression: "contractTemplate.fatherId"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": val.id
      }
    }, [_c('span', {
      staticClass: "f16 fwb"
    }, [_vm._v(_vm._s(val.name))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt20"
    }, [_vm._l((val.subList), function(va) {
      return [_c('div', {
        staticClass: "mt10"
      }, [_c('el-radio-group', {
        on: {
          "change": _vm.argeenChildrenSel
        },
        model: {
          value: (_vm.contractTemplate.childrenId),
          callback: function($$v) {
            _vm.$set(_vm.contractTemplate, "childrenId", $$v)
          },
          expression: "contractTemplate.childrenId"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": va.id
        }
      }, [_vm._v(_vm._s(va.name))])], 1), _vm._v(" "), _c('br')], 1)]
    })], 2)], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.contractTemplate.agreeDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAgree
    }
  }, [_vm._v("确认模板")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "auto mt10 mb10",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancle
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.contractForm.auth.edit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("暂存")]) : _vm._e(), _vm._v(" "), (_vm.contractForm.auth.edit && _vm.contractForm.parentContractId > 0) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit('contractForm')
      }
    }
  }, [_vm._v("推送采销")]) : _vm._e(), _vm._v(" "), (_vm.contractForm.auth.push) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit('contractForm')
      }
    }
  }, [_vm._v("推送供应商")]) : _vm._e()], 1)], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab"
  }, [_vm._v("合同详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ac4c38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/contract/edit/agreement_edit.vue
// module id = 560
// module chunks = 0